import { Component, OnInit } from '@angular/core';
import { RegisterService } from 'src/app/shared/services/register.service';
import { take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActiveDto } from 'src/app/domain/models/dto/active.dto';
import { NotifierService } from 'angular-notifier';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-register-reset-password',
  templateUrl: './register-reset-password-finish.component.html',
  styleUrls: ['./register-reset-password-finish.component.scss'],
})
export class RegisterResetPasswordFinishComponent implements OnInit {
  hide = true;

  private readonly notifier: NotifierService;
  key: string = '';
  tenant: string = '';
  merchant: string = '';
  personType: string = '';
  activeForm: FormGroup;
  public loading: boolean;

  get active(): ActiveDto {
    return this.activeForm.value;
  }
  get activeControl() {
    return this.activeForm.controls;
  }

  set active(active: ActiveDto) {
    if (active) {
      this.activeForm.patchValue(active);
    }
  }

  get password() {
    return this.activeForm.get('password');
  }
  isMobile: boolean;

  constructor(
    notifierService: NotifierService,
    private readonly router: Router,
    private readonly merchantService: MerchantService,
    public tenantService: TenantGeneralService,
    private readonly route: ActivatedRoute,
    private readonly registerService: RegisterService,
    private fb: FormBuilder
  ) {
    this.notifier = notifierService;
    this.personType = this.route.snapshot.data['personType'];
    let password = new FormControl('', [
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(100),
    ]);

    this.activeForm = fb.group({
      password: password,
      passwordConfirm: password,
    });

    this.route.paramMap.subscribe((params) => {
      const result = params.get('personType');

      if (result) this.personType = params.get('personType');
    });
  }

  ngOnInit(): void {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.route.queryParams.subscribe((params) => {
      this.key = params?.key;
    });

    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
    this.merchant = this.merchantService.getLoginMerchant(this.tenant);
  }

  goToLogin() {
    this.router.navigateByUrl(
      `${this.tenant}/login/forgot-password?m=${this.merchant}`
    );
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.activeForm.dirty && this.activeForm.valid) {
      this.loading = true;
      this.registerService
        .resetPassword(this.key, this.active.password)
        .pipe(take(1))
        .subscribe(
          (res: any) => {
            this.notifier.notify('success', 'Senha redefinida com sucesso!');
            this.loading = false;

            this.router.navigateByUrl(
              `${this.tenant}/login?m=${this.merchant}`
            );
          },
          (error) => {
            this.loading = false;
            this.active = new ActiveDto();
          }
        );
    } else {
      this.loading = false;
    }
  }
}
